import axios from "axios";
import { Message } from "element-ui";
import userStore from "../store/modules/user";
import commonAppStore from "@common/src/store/modules/app";
import countryConf from "@/config/country";
import router from "../router";
import t from "@common/src/i18n/t";
import { getTimezone } from "@common/src/utils/common";

let api_url = "";
let h5_site_url = "";
switch (window.location.host) {
  case "speedbiz.cn.gtech.asia":
    api_url = "https://speedbiz-api.cn.gtech.asia";
    h5_site_url = "https://speedbiz-h5.cn.gtech.asia";
    break;
  case "speedbiz-test.gtech.asia":
    api_url = "https://speedbiz-api-test.gtech.asia";
    h5_site_url = "https://speedbiz-h5-test.gtech.asia";
    break;
  case "speedbiz-test.gtechcloud.cn":
    api_url = "https://speedbiz-api-test.gtechcloud.cn";
    h5_site_url = "https://speedbiz-h5-test.gtechcloud.cn";
    break;
  case "speedbiz-dev.gtech.asia":
    api_url = "https://speedbiz-api-dev.gtech.asia";
    h5_site_url = "https://speedbiz-h5-dev.gtech.asia";
    break;
  case "speedbiz.my.gtech.asia":
    api_url = "https://speedbiz-api.my.gtech.asia";
    h5_site_url = "https://speedbiz-h5.my.gtech.asia";
    break;
  case "speedbiz-my-test.gtech.asia":
    api_url = "https://speedbiz-my-api-test.gtech.asia";
    h5_site_url = "https://speedbiz-h5-my-test.gtech.asia";
    break;
  case "speedbiz-my-dev.gtech.asia":
    api_url = "https://speedbiz-my-api-dev.gtech.asia";
    h5_site_url = "https://speedbiz-h5-my-dev.gtech.asia";
    break;
  default:
    api_url = `${window.location.origin}/api`;
    h5_site_url = "https://speedbiz-h5-dev.gtech.asia";
    break;
}
window.API_URL = api_url;
window.H5_SITE_URL = h5_site_url;

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.apiUrl, // api的base_url
  baseURL: api_url, // api的base_url
  timeout: 15000 // 请求超时时间,
});

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers["userLanguage"] =
      countryConf[commonAppStore.state.country]?.["useLang"]?.[commonAppStore.state.lang]?.["serverHeaderStr"] ??
      "zh-CN";
    config.headers["userAuthToken"] = userStore.state.token;
    config.headers["timezone"] = getTimezone();
    config.headers["clientType"] = "WEB";
    config.headers["appVersion"] = "3.4.0"; //每个版本需要更新版本号
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非0是抛错 结合业务进行修改
     */
    const res = response.data;
    if (res.code !== "0") {
      if (
        res.code === "speedbiz.error-user-auth-token" ||
        res.code === "speedbiz.empty-user-auth-token" ||
        res.code === "speedbiz.app-version-expire-error"
      ) {
        if (res.code === "speedbiz.app-version-expire-error") {
          // 账号过期，既要退出又要提示错误
          Message.error({
            message: res.message,
            offset: 11,
            duration: 2000
          });
        }
        router.push("/login");
        return Promise.reject(res);
      }
      if (response.config.options.errorMessage) {
        Message.error({
          message: res.message,
          offset: 11,
          duration: 2000
        });
      }
      return Promise.reject(res);
    }
    return res;
  },
  error => {
    // 错误处理
    try {
      switch (error.response.status) {
        case 500:
          error.message = t("v210801.server-abnormal"); // 明确返回500
          break;
        case 404:
          error.message = t("v210801.server404"); // 明确返回404
          break;
        default:
          error.message = t("v210801.unknown-error"); // 其他错误code
      }
    } catch (e) {
      error.message = t("v210801.network-traffic"); // 超时 获取不到status
    }
    console.log("error：" + JSON.stringify(error.message));
    if (error.config?.options?.errorMessage) {
      Message.error({
        message: error.message,
        offset: 11,
        duration: 2000
      });
    }
    return Promise.reject(error);
  }
);

const verifySign = function (param) {
  const constParams = {
    timestamp: Date.now(),
    appCode: "speedbiz"
  };
  const body = param || {};
  Object.assign(body, constParams);
  return body;
};

export function httpServer(url, params, options = { errorMessage: true }) {
  return service({
    url: url,
    method: "post",
    data: verifySign(params),
    options: options
  });
}
